import React from 'react';
import {
  Box,
  Popover,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  LinearProgress,
} from '@mui/material';
import PropTypes from 'prop-types';
import commonUtils from '../../../utils/commonUtils';

export default function AdvanceReceivedPopover({ open, anchorEl, onClosePopover, loading, data }) {
  const renderData = () => {
    if (loading)
      return (
        <Box
          sx={{
            minHeight: '100px',
            minWidth: '150px',
          }}
        >
          <LinearProgress />
        </Box>
      );

    if (data.length)
      return (
        <TableContainer>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Information</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={commonUtils.generateUUID()}>
                  <TableCell>{row.detail}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );

    return (
      <Box
        sx={{
          minHeight: '100px',
          minWidth: '150px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography>No Data</Typography>
      </Box>
    );
  };

  return (
    <Popover
      id='mouse-over-popover'
      sx={{
        pointerEvents: 'none',
      }}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={onClosePopover}
      disableRestoreFocus
    >
      {renderData()}
    </Popover>
  );
}

AdvanceReceivedPopover.defaultProps = {
  data: [],
};

AdvanceReceivedPopover.propTypes = {
  open: PropTypes.oneOf([null, PropTypes.element]).isRequired,
  anchorEl: PropTypes.oneOf([null, PropTypes.element]).isRequired,
  loading: PropTypes.bool.isRequired,
  onClosePopover: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      rep_id: PropTypes.string.isRequired,
      doctor_id: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      detail: PropTypes.string.isRequired,
    }),
  ),
};
